import { defineMessages } from 'react-intl';

export const reportIssueResultMessages = defineMessages({
  submitted: {
    defaultMessage: 'Thanks! The issue is logged. We will contact you via email.',
    id: 'uiR37IUA1G',
    description: 'Result card text after an issue report is submitted',
  },
  submittedSafety: {
    defaultMessage:
      'Thanks. Our clinical safety team has your report and will contact you by email.',
    id: 'u0Gb0N2u5L',
    description: 'Result card text after a clinical safety report is submitted',
  },
  failedTitle: {
    defaultMessage: "We couldn't send your report",
    id: 'Vg2mIAOXaU',
    description: 'Result card title when the report failed to send',
  },
  failedBody: {
    defaultMessage: 'Try again, or contact support from the Help menu.',
    id: 'Qx+0teFVqO',
    description: 'Result card body when the report failed to send',
  },
});
